(function () {
  const triggers = document.querySelectorAll('[data-whatsapp-trigger]');
  if (!triggers.length) return;

  let openPopup = null;

  function closePopup(popup, trigger) {
    if (!popup || !trigger) return;
    popup.classList.remove('is-open');
    popup.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    if (openPopup === popup) openPopup = null;
  }

  function openWhatsAppPopup(popup, trigger) {
    if (openPopup && openPopup !== popup) {
      const activeTrigger = document.querySelector('[aria-controls="' + openPopup.id + '"]');
      if (activeTrigger) closePopup(openPopup, activeTrigger);
    }

    popup.hidden = false;
    popup.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    openPopup = popup;
  }

  triggers.forEach(function (trigger) {
    const popupId = trigger.getAttribute('aria-controls');
    const popup = popupId ? document.getElementById(popupId) : null;
    if (!popup) return;

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      const isOpen = popup.classList.contains('is-open');
      if (isOpen) {
        closePopup(popup, trigger);
      } else {
        openWhatsAppPopup(popup, trigger);
      }
    });
  });

  document.addEventListener('click', function (event) {
    if (!openPopup) return;
    const activeTrigger = document.querySelector('[aria-controls="' + openPopup.id + '"]');
    if (!activeTrigger) return;
    if (openPopup.contains(event.target) || activeTrigger.contains(event.target)) return;
    closePopup(openPopup, activeTrigger);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !openPopup) return;
    const activeTrigger = document.querySelector('[aria-controls="' + openPopup.id + '"]');
    if (!activeTrigger) return;
    closePopup(openPopup, activeTrigger);
    activeTrigger.focus();
  });
})();
